document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('.page-content--product .product-single__form');

  const getCurrentVariantId = (form) => {
    const checkedVariantInput = form.querySelector('.variant-input input:checked');

    if (checkedVariantInput) {
      const sectionId = checkedVariantInput.className.match(/variant__input-(\S+)/);
      const variantSelectBySection = sectionId
        ? form.querySelector(`#ProductSelect-${sectionId[1]}`)
        : null;

      if (variantSelectBySection && variantSelectBySection.value) {
        return variantSelectBySection.value.trim();
      }
    }

    const variantSelect = form.querySelector('select[name="id"]');

    if (variantSelect && variantSelect.value) {
      return variantSelect.value.trim();
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    const variantParam = urlSearchParams.get('variant');

    return variantParam ? variantParam.trim() : null;
  };

  if(productForm){
    const variantNoteItems = productForm.querySelectorAll('.product__variants-hintShipping .varaint__item-hintShipping');
    const noteShippingEl = productForm.querySelector('.product__variant-note');
    const defaultNoteEl = productForm.querySelector('.product__variant-note-default');
    const initialVariantId = noteShippingEl ? noteShippingEl.dataset.initialVariantId : null;

    const updateShippingNote = (variantIdFromEvent) => {
      if (!noteShippingEl) {
        return;
      }

      const currentVariantId = variantIdFromEvent || getCurrentVariantId(productForm) || initialVariantId;

      if (!currentVariantId) {
        noteShippingEl.style.display = 'none';
        noteShippingEl.innerHTML = '';
        return;
      }

      const currentVariantNoteItem = Array.from(variantNoteItems).find((item) => {
        return item.dataset.variantId === currentVariantId;
      });

      if (!currentVariantNoteItem) {
        noteShippingEl.style.display = 'none';
        noteShippingEl.innerHTML = '';
        return;
      }

      const variantSpecificNoteEl = currentVariantNoteItem.querySelector('.varaint__item-hintShipping-note');
      const variantSpecificNote = variantSpecificNoteEl ? variantSpecificNoteEl.innerHTML.trim() : '';
      const shouldShowGlobalNote = currentVariantNoteItem.dataset.showGlobalNote === 'true';
      const defaultNote = defaultNoteEl ? defaultNoteEl.innerHTML.trim() : '';

      if (variantSpecificNote) {
        noteShippingEl.innerHTML = variantSpecificNote;
        noteShippingEl.style.display = 'block';
        return;
      }

      if (shouldShowGlobalNote && defaultNote) {
        noteShippingEl.innerHTML = defaultNote;
        noteShippingEl.style.display = 'block';
        return;
      }

      noteShippingEl.style.display = 'none';
      noteShippingEl.innerHTML = '';
    };

    updateShippingNote();

    const variantSelect = productForm.querySelector('select[name="id"]');
    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        updateShippingNote();
      });
    }

    const variantInputs = productForm.querySelectorAll('.variant-input');
    variantInputs.forEach((variantBtn) => {
      variantBtn.addEventListener('click', () =>  {
        setTimeout(updateShippingNote, 500);
      });
    });

    const productContainer = productForm.closest('.product-single');
    if (productContainer && typeof jQuery !== 'undefined') {
      jQuery(productContainer).on('variantChange', function(event) {
        const variantId = event && event.variant && event.variant.id ? String(event.variant.id) : null;
        updateShippingNote(variantId);
      });
    }
  }
})
